<template>
    <div class="foot">
        <div class="footer_main">
            <div class="codeFlex">
                <div class="app">
                    <p>APP客户端</p>
                    <img :src="configList.app_ercode" alt="" />
                </div>
                <div class="app">
                    <p>微信服务号</p>
                    <img src="../assets/common/fwh.jpg" alt="" />
                </div>
                <div class="app">
                    <p>微博</p>
                    <img src="../assets/common/wbewm.jpg" alt="" />
                </div>
                <div class="app">
                    <p>抖音</p>
                    <img src="../assets/common/dy.png" alt="" />
                </div>
                <div class="app_q">
                    <img src="../assets/common/q.png" alt="" width="94" height="133" />
                </div>
            </div>
            <div class="text">
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502035637" target="_blank"
                    style="display: flex;
          align-items: center;">
                    <img src="//static.zaimanhua.com/public/images/beiantubiao.png" style="margin-right: 10px;" />
                    {{ configList.police_icp }}
                </a>
                <span class="spacer">|</span>
                <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
                    {{ configList.icp }}
                </a>
                <span class="spacer">|</span>
                <a target="_blank" href="https://images.zaimanhua.com/default/zmh-www.jpg">
                    网络文化经营许可证：{{ configList.license }}
                </a>
                <span class="spacer">|</span>
                <a href="https://www.12377.cn/" target="_blank">有害信息举报</a>
            </div>
            <div class="text mb0">
                <p>
                    举报电话：010-64141207
                </p>
                <span class="spacer">|</span>
                <p>
                    举报邮箱：kefu@zaimanhua.com
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { getConfigList } from "@/api/common";
import { ref } from 'vue';
const configList = ref({})

const footerList = async () => {
    const res = await getConfigList({})
    configList.value = res.data
}

footerList()
</script>

<style>
@import "style.scss";

.mb0 {
    margin-bottom: 0;
}
</style>